module.exports = __webpack_public_path__ + "static/img/1.d9b08a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/demo1/source/1.png
// module id = v7fC
// module chunks = 1